import ApiService from '@/services/core/api.service'

const SSOService = {
  async post (payload) {
    return ApiService.post('auth/sso/oauth2', payload)
  }
}

export default SSOService
